(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-header-sidebar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-menu-drawer')) {
    customElements.define('cm-menu-drawer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.openers = () => [...document.querySelectorAll('[aria-controls="sidebar-menu"]')];
        this.setExpanded = value => this.openers().forEach(button => button.setAttribute('aria-expanded', String(value)));
        this.setExpanded(false);
        document.addEventListener('click', event => {
          const opener = event.target.closest?.('[aria-controls="sidebar-menu"]');
          if (!opener) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.previousFocus = opener;
          this.dialog.showModal();
          document.body.classList.add('cm-menu-lock');
          this.setExpanded(true);
        }, options);
        this.dialog.addEventListener('click', event => {
          const box = this.dialog.getBoundingClientRect();
          const outside = event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
          if (outside || event.target.closest?.('[data-cm-menu-close], a[href]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('cm-menu-lock');
          this.setExpanded(false);
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex="0"]')].filter(item => item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
          const first = items[0];
          const last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
        }, options);
        this.dialog.addEventListener('toggle', event => {
          const opened = event.target;
          if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
          this.dialog.querySelectorAll('details[open]').forEach(item => { if (item !== opened) item.open = false; });
        }, { ...options, capture: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.classList.remove('cm-menu-lock');
          this.setExpanded(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
